import React, { useState } from "react";
import { FaCaretDown, FaCaretUp } from "react-icons/fa6";

const FAQCard = ({ question, answer, isOpen: externalIsOpen, onToggle }) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  
  const isControlled = onToggle !== undefined;
  const isOpen = isControlled ? externalIsOpen : internalIsOpen;
  
  const handleToggle = () => {
    if (isControlled) {
      onToggle();
    } else {
      setInternalIsOpen(!internalIsOpen);
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg hover:border-[#FF5F00] transition-all duration-300">
      <div
        className="py-4 px-5 md:px-6 cursor-pointer transition-all duration-300 flex justify-between items-center gap-4"
        onClick={handleToggle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="flex items-center gap-3 flex-1">
          <h3 className={`font-semibold text-base md:text-lg transition-colors duration-300 ${
            isHovered ? 'text-[#FF5F00]' : 'text-black'
          }`}>
            {question}
          </h3>
        </div>
        <div className={`transition-all duration-300 ${
          isHovered ? 'text-[#FF5F00] scale-110' : 'text-[#FF5F00]'
        }`}>
          {isOpen ? (
            <FaCaretUp className="text-xl" />
          ) : (
            <FaCaretDown className="text-xl" />
          )}
        </div>
      </div>
      
      {/* Animated expand/collapse */}
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        <div className="px-5 md:px-6 pb-4 md:pb-5 text-gray-600 border-t border-gray-100">
          <p className="text-sm md:text-base leading-relaxed">{answer}</p>
        </div>
      </div>
    </div>
  );
};

export default FAQCard;